import { useStep } from "react-hooks-helper";
import { useState, useContext, useEffect } from "react";
import { createUserViaInvite, getInviteDetails } from "../../../services/auth";
import { validateData } from "../../../services/auth";
import { RequestLoader } from "../../../hooks/context";
import { useNavigate } from "react-router-dom";
import useGrantAccessToApp from "../../../hooks/useGrantAccessToApp";
import { useGetProfileDetails } from "../../../hooks/api/queries/useSettings";
import { pathConstants } from "../../../routes/pathContants";
import { cleanObject } from "../../../helpers";

const InviteSignupLogic = () => {
  const params = new URLSearchParams(window.location.search);
  const refId = params.get("ref");
  const [email, setEmail] = useState(params.get("email") || "");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [country, setCountry] = useState("");
  const [currency, setCurrency] = useState("");
  const [countryCode, setCountryCode] = useState("234");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [isCreatingAccount, setIsCreatingAccount] = useState(false);
  const [isValidatingData, setisValidatingData] = useState(false);
  const navigate = useNavigate();
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const [showRegistrationFlow, setShowRegistrationFlow] = useState(false);
  const [tokens, setTokens] = useState({
    refreshToken: null,
    accessToken: null,
  });
  const { isLoading, data: profileDetails } = useGetProfileDetails({
    isProfileEnabled: tokens?.accessToken ? true : false,
    accessToken: tokens?.accessToken,
  });
  const { setAuthTokensAndGrantAccessToApp } = useGrantAccessToApp({
    message: "Registration successful",
  });

  useEffect(() => {
    if (refId === undefined || refId === null)
      return navigate(pathConstants.SIGNUP);

    getInviteDetails(refId)
      .then((response) => {
        setEmail(response?.data?.data?.email);
        setFirstName(response?.data?.data?.first_name);
        setLastName(response?.data?.data?.last_name);
        setPhoneNumber(response?.data?.data?.phone_number?.replace(/^\+/, ""));
      })
      .catch(() => {
        navigate(pathConstants.LOGIN);
      })
      .finally(() => {
        setShowRegistrationFlow(true);
      });
  }, []);

  useEffect(() => {
    if (!isLoading && tokens?.refreshToken) getUserProfileDetailsAndLogin();
  }, [isLoading, tokens]);

  const { index, navigation } = useStep({
    steps: 2,
    initialStep: 0,
  });
  const handleNextStep = () => {
    validatEmailAndPhoneNumber();
  };

  const handlePreviousStep = () => {
    navigation.previous();
  };

  const validatEmailAndPhoneNumber = () => {
    setisValidatingData(true);
    setRequestLoaderProgress(60);
    validateData({
      email: email,
      phone_number: `${phoneNumber}`,
      country_code: countryCode,
    })
      .then((response) => {
        if (response?.data?.data?.email?.available === false) {
          window.setError(
            "email",
            {
              type: "validate",
              message: "Email already exist",
            },
            { shouldFocus: true },
          );
        }
        if (response?.data?.data?.phone_number.available === false) {
          window.setError(
            "phoneNumber",
            {
              type: "validate",
              message: "Phone number already exist",
            },
            { shouldFocus: true },
          );
        }
        if (
          response?.data?.data?.email?.available === false ||
          response?.data?.data?.phone_number?.available === false
        )
          return;
        navigation.next();
      })
      .catch(() => {})
      .finally(() => {
        setRequestLoaderProgress(100);
        setisValidatingData(false);
      });
  };

  const createAccount = () => {
    setRequestLoaderProgress(50);
    setIsCreatingAccount(true);
    createUserViaInvite(
      cleanObject({
        email: email,
        first_name: firstName,
        last_name: lastName,
        country_code: countryCode,
        phone_number: `${phoneNumber}`,
        job_title: jobTitle,
        password: password,
        confirm_password: confirmPassword,
        agree_terms: agreeToTerms,
        invite_ref: params.get("ref"),
        is_web: true,
      }),
    )
      .then((response) => {
        const { access, refresh } = response?.data?.data;
        setTokens({
          refreshToken: refresh,
          accessToken: access,
        });
      })
      .finally(() => {
        setRequestLoaderProgress(100);
        setIsCreatingAccount(false);
      });
  };

  const getUserProfileDetailsAndLogin = () => {
    setAuthTokensAndGrantAccessToApp({
      refreshToken: tokens?.refreshToken,
      accessToken: tokens?.accessToken,
      profileDetails: profileDetails,
    });
  };

  return {
    handleNextStep,
    handlePreviousStep,
    setCountry,
    country,
    setCurrency,
    currency,
    setCountryCode,
    countryCode,
    setEmail,
    email,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    phoneNumber,
    setPhoneNumber,
    jobTitle,
    setJobTitle,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    index,
    agreeToTerms,
    setAgreeToTerms,
    createAccount,
    isCreatingAccount,
    isValidatingData,
    showRegistrationFlow,
  };
};

export default InviteSignupLogic;
